var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8127 4.6379C21.6411 3.8095 21.6411 2.46638 20.8127 1.63797L20.3612 1.18649C19.5328 0.358083 18.1897 0.358084 17.3613 1.18649L10.9992 7.54856L4.63717 1.18649C3.80876 0.358086 2.46565 0.358084 1.63724 1.18649L1.18576 1.63797C0.357351 2.46638 0.357352 3.80949 1.18576 4.6379L7.54783 11L1.18576 17.362C0.357353 18.1904 0.357351 19.5336 1.18576 20.362L1.63724 20.8134C2.46565 21.6419 3.80876 21.6419 4.63717 20.8134L10.9992 14.4514L17.3613 20.8134C18.1897 21.6418 19.5328 21.6419 20.3612 20.8134L20.8127 20.362C21.6411 19.5336 21.6411 18.1904 20.8127 17.362L14.4506 11L20.8127 4.6379Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailIcon);
export default __webpack_public_path__ + "static/media/fail-icon.bbc1beadb49b6872fe3a78ac6fe6f232.svg";
export { ForwardRef as ReactComponent };